import { atom } from 'jotai'

import { type DraggingShipmentOrder } from '../../-models'

/**
 * ドラッグ中の配送依頼（新規に配車するパターン）
 */
export const draggingShipmentOrderAtom = atom<DraggingShipmentOrder | null>(
  null
)

draggingShipmentOrderAtom.debugLabel = 'draggingShipmentOrderAtom'
